import { useEffect } from 'react';

interface ClosePageAlertProps {
  showAlert: boolean;
}

export const useClosePageAlert = ({ showAlert }: ClosePageAlertProps) => {
  useEffect(() => {
    if (!showAlert) {
      return;
    }

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // This doesn't work in Chrome (and possibly other browsers) for security and protection against scammers. See issue from chromium here: https://issues.chromium.org/issues/41240086.
      // Chrome will always display the browser's generic default message, instead of what's returned here.
      return 'Your interview is not complete and will not be paused if you close this page. Are you sure you want to leave?';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [showAlert]);
};
